// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__1x3Eq","content":"Layout_content__Z_OBU","reveal-media":"Layout_reveal-media__qIRZz"};